import { RequestPoolManager } from './requestPoolManager.js';
import RequestType from '../enums/RequestType.js';
const imageRetrievalPoolManager = new RequestPoolManager('imageRetrievalPool');
imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType.Interaction, 200);
imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType.Thumbnail, 200);
imageRetrievalPoolManager.setMaxSimultaneousRequests(RequestType.Prefetch, 200);
imageRetrievalPoolManager.grabDelay = 0;
export default imageRetrievalPoolManager;
